"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function lowercaseFirstOnly(string) {
    if (!string)
        return string;
    return string[0].toLocaleLowerCase() + string.slice(1);
}
exports.default = lowercaseFirstOnly;
